import { DataTableCellProps, TableCell } from 'components/dataTable';

const formatMaskedValue = (raw: string): string => {
  const match = raw.match(/^([^*]*)(\*+)([^*]*)$/);
  if (!match) return raw;

  const [, prefix = '', , suffix = ''] = match;
  return `${prefix}•••• ${prefix}${suffix}`;
};

export const AccountOrWalletNumberCell = ({ row, column }: DataTableCellProps) => {
  const raw = row[column.id] ?? '';
  const value = formatMaskedValue(raw);

  return <TableCell data-column={column.id}>{value}</TableCell>;
};
